module.exports = "/static/Images/pt-br/Two.png";